import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

function init(container = document) {

    const skewElems = Array.from(container.querySelectorAll('.js-velocity-skew'));

    skewElems.forEach(el => {
        const proxy = { skew: 0 };
        const setter = gsap.quickSetter(el, 'skewY', 'deg');
        const clamp = gsap.utils.clamp(el.dataset.skewMin, el.dataset.skewMax);
        ScrollTrigger.create({
            onUpdate: (self) => {
                const skew = clamp(self.getVelocity() / -300);
                if (Math.abs(skew) > Math.abs(proxy.skew)) {
                    proxy.skew = skew;
                    gsap.to(proxy, {
                        skew: 0,
                        duration: 0.8,
                        ease: 'power3',
                        overwrite: true,
                        onUpdate: () => {
                            setter(proxy.skew)
                        }
                    });
                }
            }
        });
        gsap.set(el, {transformOrigin: 'right center', force3D: true});
    });

    const rotateElems = Array.from(container.querySelectorAll('.js-velocity-rotate'));

    rotateElems.forEach(el => {
        const proxy = { rotate: 0 };
        const setter = gsap.quickSetter(el, 'rotate', 'deg');
        const clamp = gsap.utils.clamp(el.dataset.rotateMin, el.dataset.rotateMax);
        ScrollTrigger.create({
            onUpdate: (self) => {
                const rotate = clamp(self.getVelocity() / 30);
                if (Math.abs(rotate) > Math.abs(proxy.rotate)) {
                    proxy.rotate = rotate;
                    gsap.to(proxy, {
                        rotate: 0,
                        duration: 0.8,
                        ease: 'power3',
                        overwrite: true,
                        onUpdate: () => {
                            setter(proxy.rotate)
                        }
                    });
                }
            }
        });
        gsap.set(el, {transformOrigin: 'center center', force3D: true});
    });

    const translateYElems = Array.from(container.querySelectorAll('.js-velocity-translate-y'));

    translateYElems.forEach(el => {
        const proxy = { y: 0 };
        const setter = gsap.quickSetter(el, 'translateY', 'px');
        const clamp = gsap.utils.clamp(el.dataset.translateMin, el.dataset.translateMax);
        ScrollTrigger.create({
            onUpdate: (self) => {
                const y = clamp(self.getVelocity() / 30);
                if (Math.abs(y) > Math.abs(proxy.y)) {
                    proxy.y = y;
                    gsap.to(proxy, {
                        y: 0,
                        duration: 0.8,
                        ease: 'power3',
                        overwrite: true,
                        onUpdate: () => {
                            setter(proxy.y)
                        }
                    });
                }
            }
        });
        gsap.set(el, {transformOrigin: 'center center', force3D: true});
    });

}

const _module = { init }

export default _module;